import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Dra. Mariana Lopez",
    role: "Fisioterapeuta Independiente, CDMX",
    text: "Antes usaba hojas de Excel y WhatsApp para todo. Ahora mis pacientes tienen su portal, hacen sus ejercicios y yo tengo el expediente completo. La diferencia es enorme.",
    initials: "ML",
    color: "bg-emerald-400",
  },
  {
    name: "Lic. Carlos Hernandez",
    role: "Director, Clinica FisioVida Monterrey",
    text: "Lo que mas me convencio fue el concepto de episodios. Ya no son citas sueltas — veo el progreso completo del paciente. Mi equipo trabaja mucho mas coordinado.",
    initials: "CH",
    color: "bg-teal-400",
  },
  {
    name: "Dra. Sofia Ramirez",
    role: "Fisioterapeuta, Guadalajara",
    text: "Mis pacientes me dicen que el portal es super facil de usar. Marcan sus ejercicios, me reportan dolor y yo puedo ajustar el plan antes de la siguiente sesion. Continuidad real.",
    initials: "SR",
    color: "bg-cyan-400",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 relative overflow-hidden"
    >
      {/* Subtle background */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-50 to-white -z-10" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm font-semibold text-emerald-600 uppercase tracking-widest mb-3">
            Testimonios
          </p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-slate-900 tracking-tight mb-4">
            Lo que dicen nuestros fisioterapeutas
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="testimonial-card bg-white p-8 rounded-2xl border border-slate-100 shadow-sm"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, j) => (
                  <Star
                    key={j}
                    className="w-4 h-4 text-amber-400 fill-amber-400"
                  />
                ))}
              </div>

              <p className="text-sm text-slate-600 leading-relaxed mb-6 italic">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3">
                <div
                  className={`w-10 h-10 ${t.color} rounded-full flex items-center justify-center`}
                >
                  <span className="text-white text-xs font-bold">{t.initials}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-slate-800">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
